import { z } from 'zod';

export const closureShowHiddenMessageSchema = z.object({
  from_closure: z.string(),
  message: z.string(),
});

type closureShowHiddenMessageSchemaType = z.infer<typeof closureShowHiddenMessageSchema>;

const defaultValue: closureShowHiddenMessageSchemaType = {
  from_closure: '2021-01-01',
  message: 'Fechamento não liberado, aguarde a liberação',
};

export const closureShowHiddenMessageDefaultValue = JSON.stringify(defaultValue, null, '\t');
